module.exports = __webpack_public_path__ + "img/mission.48fe5274.svg";